import { docReady } from '../helpers/docReady';
import { lockBody, unlockBody } from '../helpers/bodyLock';
const selectors = {
    modal: 'data-modal',
    trigger: '[data-modal-trigger]',
};
const classes = {
    modalOpen: 'modal-open',
    modalClosed: 'modal-closed',
};
const initialiseModalTrigger = (trigger) => {
    trigger.addEventListener('click', () => {
        const modalId = trigger.dataset.modalTrigger;
        const modal = document.querySelector(`[${selectors.modal}="${modalId}"]`);
        if (modal) {
            const isOpen = isModalOpen(modal);
            if (!isOpen) {
                setModalOpen(modal);
                lockBody();
            }
            else {
                setModalClosed(modal);
                unlockBody();
            }
        }
    });
};
const isModalOpen = (modalElement) => {
    return modalElement.classList.contains(classes.modalOpen);
};
const setModalOpen = (modalElement) => {
    modalElement.classList.remove(classes.modalClosed);
    modalElement.classList.add(classes.modalOpen);
};
const setModalClosed = (modalElement) => {
    modalElement.classList.add(classes.modalClosed);
    modalElement.classList.remove(classes.modalOpen);
};
docReady(() => {
    const modalTriggers = Array.from(document.querySelectorAll(selectors.trigger));
    modalTriggers.forEach((triggerElement) => initialiseModalTrigger(triggerElement));
});
